(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-fit-check"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-product-fit-check]');
    if (!root) return;

    const COOKIE = 'mm_garage';
    function readGarage() {
      const m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      if (!m) return { bikes: [], activeBikeId: null };
      try { return JSON.parse(decodeURIComponent(m[1])); }
      catch (_) { return { bikes: [], activeBikeId: null }; }
    }

    function setMessage(html) {
      const message = root.querySelector('[data-fit-message]');
      if (!message) return;
      // Use textContent for safety, then optionally bold the bike name via DOM
      message.replaceChildren();
      const parser = new DOMParser();
      const doc = parser.parseFromString('<p>' + html + '</p>', 'text/html');
      const p = doc.body.firstChild;
      Array.from(p.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          message.appendChild(document.createTextNode(n.textContent));
        } else if (n.tagName === 'STRONG') {
          const s = document.createElement('strong');
          s.textContent = n.textContent;
          message.appendChild(s);
        }
      });
    }

    /* Model metaobject names are stored make-prefixed ("BMW R1300GS"), so
       composing year + manufacturer + model naively reads "BMW BMW R1300GS".
       DISPLAY ONLY — `active.model` is still compared verbatim below, because
       it is the key matched against the product's bike.model values.
       Byte-identical to stripMakePrefix in sections/header.liquid and to
       model_label in migration/src/build_bike_selector.py; keep all three in
       step if the rule changes. */
    function stripMakePrefix(modelName, makeName) {
      if (!modelName || !makeName) return modelName || '';
      const prefix = makeName + ' ';
      if (modelName.slice(0, prefix.length).toLowerCase() !== prefix.toLowerCase()) {
        return modelName;
      }
      // Only the first occurrence, and never strip down to nothing.
      return modelName.slice(prefix.length).replace(/^\s+/, '') || modelName;
    }

    function check() {
      const initialState = root.dataset.state;
      if (initialState === 'universal') return;

      const ms = (root.dataset.fitManufacturers || '').split('|').filter(Boolean);
      const md = (root.dataset.fitModels || '').split('|').filter(Boolean);
      const yr = (root.dataset.fitYears || '').split('|').filter(Boolean);

      const garage = readGarage();
      const active =
        garage.bikes.find((b) => b.id === garage.activeBikeId) || garage.bikes[0];

      if (!active) {
        root.dataset.state = 'select';
        setMessage('Select your bike to <strong>check fit</strong>');
        return;
      }

      const matchMfr = ms.length === 0 || ms.includes(active.manufacturerHandle);
      const matchModel = md.length === 0 || md.includes(active.model);
      const matchYear = yr.length === 0 || yr.includes(String(active.year));

      const bikeName =
        active.year +
        ' ' +
        active.manufacturer +
        ' ' +
        stripMakePrefix(active.model, active.manufacturer);

      if (matchMfr && matchModel && matchYear) {
        root.dataset.state = 'match';
        setMessage('This product fits your <strong>' + bikeName + '</strong>');
      } else {
        root.dataset.state = 'no-match';
        setMessage('This part doesn’t fit your <strong>' + bikeName + '</strong>');
      }
    }

    check();
    document.addEventListener('garage:changed', check);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-product-gallery]');
    if (!root) return;
    const heroImg = root.querySelector('.product-gallery__hero-image');
    const heroBox = root.querySelector('[data-gallery-hero]');
    const thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!heroBox || thumbs.length === 0) return;

    function activate(button) {
      thumbs.forEach((b) => {
        const on = b === button;
        b.classList.toggle('product-gallery__thumb--active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      /* Keep the active thumb visible in the horizontal slider. */
      try {
        button.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      } catch (_) { /* older browsers without smooth option */ }

      if (heroImg) {
        const newSrc = button.dataset.mediaUrl;
        const newAlt = button.dataset.mediaAlt;
        const newW = button.dataset.mediaWidth;
        const newH = button.dataset.mediaHeight;
        if (newW) heroImg.setAttribute('width', newW);
        if (newH) heroImg.setAttribute('height', newH);
        if (newSrc) heroImg.src = newSrc;
        if (newAlt) heroImg.alt = newAlt;
        heroImg.removeAttribute('srcset');
      }
    }

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => activate(btn));
      btn.addEventListener('keydown', (e) => {
        const arr = Array.from(thumbs);
        const idx = arr.indexOf(btn);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          (arr[idx + 1] || arr[0]).focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          (arr[idx - 1] || arr[arr.length - 1]).focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(btn);
        }
      });
    });

    /* ─── Variant change → swap hero to the variant's featured image ─── */
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail && e.detail.variant;
      if (!variant || !variant.featured_image) return;

      const imgId = String(variant.featured_image.id);
      const matchingThumb = Array.from(thumbs).find(
        (t) => t.dataset.imageId === imgId
      );
      if (matchingThumb) {
        activate(matchingThumb);
        return;
      }

      /* No matching thumbnail — swap the hero directly. */
      if (heroImg) {
        const img = variant.featured_image;
        if (img.width) heroImg.setAttribute('width', img.width);
        if (img.height) heroImg.setAttribute('height', img.height);
        const src = img.src || img.url;
        if (src) heroImg.src = src;
        heroImg.alt = img.alt || variant.name || '';
        heroImg.removeAttribute('srcset');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sort-by"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-sort-by-select]');
      if (!sel) return;
      const form = sel.form;
      if (form) form.submit();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      const variantsScript = this.querySelector('[data-variants]');
      if (!variantsScript) return;
      try { this.variants = JSON.parse(variantsScript.textContent); } catch (_) { this.variants = []; return; }

      this.idInput = this.querySelector('[data-variant-id]');
      this.selects = this.querySelectorAll('select[data-option-index]');
      this.selects.forEach((s) => s.addEventListener('change', () => this.updateSelection()));
    }

    readSelection() {
      const groups = new Map();
      this.selects.forEach((s) => groups.set(Number(s.dataset.optionIndex), s.value));
      const max = Math.max(...groups.keys()) + 1;
      const opts = [];
      for (let n = 0; n < max; n++) opts.push(groups.get(n));
      return opts;
    }

    updateSelection() {
      const sel = this.readSelection();
      const matched = this.variants.find((v) =>
        v.options.length === sel.length && v.options.every((opt, i) => opt === sel[i])
      );
      if (!matched) return;
      if (this.idInput) this.idInput.value = matched.id;
      this.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: matched, allVariants: this.variants }
      }));
    }
  }

  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
